import { render } from "./ShippingBasics.vue?vue&type=template&id=33ccc1de&scoped=true"
import script from "./ShippingBasics.vue?vue&type=script&lang=js"
export * from "./ShippingBasics.vue?vue&type=script&lang=js"

import "./ShippingBasics.vue?vue&type=style&index=0&id=33ccc1de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33ccc1de"]])

export default __exports__